export default (axios, code) => axios.get(`/ticket/check?ticketCode=${code}`);
